<template lang="pug">
  e-modal(
    @close="onClose"
    @confirm="getOptimalZones"
    title="Модельные зоны РО"
    saveBtnLabel="Смоделировать"
  )
    slot
      e-form(:formValidator="formValidator")
        e-form-group(
          name="container_cost"
          label="Стоимость контейнера (руб)"
          :model="fields"
          tabView="tab1"
          :required="true"
        )
        e-form-group(
          name="transport_cost"
          label="Стоимость ТС (руб. на 1 машину)"
          :model="fields"
          tabView="tab1"
          :required="true"
        )
        e-form-group(
          name="transport_service_cost"
          label="Стоимость тех. обслуживания ТС (руб. на 1 машину)"
          :model="fields"
          tabView="tab1"
          :required="true"
        )
        e-form-group(
          name="transport_fuel_consumption"
          label="Расход топлива ТС (на км.)"
          :model="fields"
          tabView="tab1"
          :required="true"
        )
        e-form-group(
          name="transport_fuel_cost"
          label="Стоимость топлива (руб.)"
          :model="fields"
          tabView="tab1"
          :required="true"
        )
        e-form-group(
          name="transport_capacity_ton"
          label="Грузоподъемность ТС (тонн)"
          :model="fields"
          tabView="tab1"
          :required="true"
        )
        e-form-group(
          name="driver_salary"
          label="ЗП водителя (руб. в мес.)"
          :model="fields"
          tabView="tab1"
          :required="true"
        )
        e-form-group(
          name="perform_operation_cost"
          label="Операционные затраты на обработку ОИТ (руб.)"
          :model="fields"
          tabView="tab1"
          :required="true"
        )
        e-form-group(
          name="trips_per_transport"
          label="Количество рейсов в год на 1 машину"
          :model="fields"
          tabView="tab1"
          :required="true"
        )
        e-form-group(
          name="fixed_control_cost"
          label="Фиксированные затраты на управление (руб.)"
          :model="fields"
          tabView="tab1"
          :required="true"
        )
        e-form-group(
          name="not_fixed_control_cost"
          label="Удельные переменные затраты на управление 1 тонной отходов (руб.)"
          :model="fields"
          tabView="tab1"
          :required="true"
        )
</template>
<script>
import formBaseMixin from '@/components/form/form-base-mixin'
import { atu } from '@/api/api-endpoints'
import year from '@/utils/year'

export default {
  name: 'OptimalZones',
  mixins: [formBaseMixin],
  props: {
    year: {
      type: Number,
      default: year.getCurrentYear(),
    },
  },
  data() {
    return {
      fields: {
        container_cost: '',
        transport_cost: '',
        transport_service_cost: '',
        transport_fuel_consumption: '',
        transport_fuel_cost: '',
        transport_capacity_ton: '',
        driver_salary: '',
        perform_operation_cost: '',
        trips_per_transport: '',
        fixed_control_cost: '',
        not_fixed_control_cost: '',
      },
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    async getOptimalZones() {
      if (!Object.values(this.fields).every((item) => item !== '')) {
        this.$e.errorBox('Заполните обязательные поля!')
        return false
      }
      this.$bar.start()
      const zones = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.modeling({
            query: { ...this.fields, year: this.year },
          }),
        })
      ).data
      this.$bar.finish()
      this.$emit('setOptimalZones', zones)
      this.onClose()
    },
  },
}
</script>
